import { UserType } from '../common/model';
import { applicationRoleTypes } from '../mock/roleTypes';

export const findUserAccessType = (roleName?: string): UserType | undefined => {
	return [...applicationRoleTypes].find(
		role => role.name.toLocaleLowerCase().trim() === roleName?.toLocaleLowerCase().trim()
	)?.accessType;
};
